export const CEP_LENGTH = 8; // eslint-disable-line
